<template>
<div>
    <div class="link-btn pt-4" @click="returnToOptions">
        <v-icon small color="primary">arrow_back_ios</v-icon> Escolher outra forma de pagamento
    </div>
    <v-layout class="mt-4">
        <label class="title-card">Pagar com</label>
        <v-img max-height="24" width="72" max-width="72" class="ml-2" flat src="https://logospng.org/download/pix/logo-pix-1024.png"></v-img>
    </v-layout>
    <v-layout justify-center style="min-width: 300px; min-height: 300px;">
        <div style="padding-top: 50px;" v-if="loadingQRcode">
            <v-layout justify-center class="mt-4 mb-4">
             <span class="footer-card">Por favor Aguarde...</span>
            </v-layout>
            <v-layout justify-center>
                <half-circle-spinner class="loading-circular" :animation-duration="1000" :size="60" color="#0067af" />
            </v-layout>
        </div>
        <v-img v-else-if="pixDetails" flat max-width="300" :src="`data:image/png;base64, ${pixDetails.qrcode_image.imagem_base64}`"></v-img>
    </v-layout>
    <div v-if="pixDetails">
        <v-layout v-if="$route.name !== 'totem'">
           <input type="hidden" id="copy-domain" readonly="readonly" :value="pixDetails.qrcode_image.emv">
            <v-btn
                block
                round
                depressed
                class="normal-text mt-4"
                color="primary"
                dark
                @click="copyCode"
                :loading="pixDetails && !pixDetails.qrcode_image"
                >Copiar Código</v-btn>
        </v-layout>
    </div>
    <v-layout justify-center class="mt-2 mb-4">
        <span class="footer-card">Você será redirecionado automaticamente <p class="footer-card">assim que o pagamento for processado.</p></span>
    </v-layout>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import $http from '@/http.js';
import { HalfCircleSpinner } from 'epic-spinners';
import * as Sentry from "@sentry/vue";

export default {
  components: {
    HalfCircleSpinner
  },
  data() {
    return {
      loadingQRcode: true,
      tryCheckStatus: true,
      seconds: 0,
      intervalSeconds: null,
      executeStatus: true,
      countRequest: 0,
      timer: 1000,
      expired: false
    };
  },
  computed: {
      ...mapGetters([
      'cartProducts',
      'expirationDialog'
    ]),
   productsTotal() {
      let total = 0;
      let somador = 0;
      this.cartProducts.forEach(p => {
        p.forEach(v => {
          somador += (v.valor + v.valor_conveniencia) * v.quantidade;
        });
      });
      total = somador;
      return total * 100;
    },
    productsDiscount () {
        let total = this.productsTotal
        let discount = total * (0.05)
        return discount
    },
    pixDetails() {
      return this.$store.getters.pixDetails;
    },
    pixIsSelected() {
      return this.$store.getters.pixIsSelected;
    },
    pixOrderStatus() {
      return this.$store.getters.pixOrderStatus;
    },
    pingPix: {
      get () {
        return this.$store.getters.pingPix
      },
      set (val) {
        this.$store.dispatch('setPingPix', val)
      }
    }
  },

  mounted() {
    this.executeStatus = true
    this.clearIntervalPing()
  },
  watch: {
      expirationDialog (v) {
        if (v) {
          this.expired = true
          clearInterval(this.intervalSeconds)
        }
      },
      pixDetails () {
          if (this.pixDetails && this.pixDetails.order_hash && this.tryCheckStatus) {
              this.checkPurchaseStatus()
          }
          if (this.pixDetails && this.pixDetails.qrcode_image) {
            setTimeout(() => {
              this.loadingQRcode = false
            }, 1500)
          }
      },
      pixOrderStatus (v) {
        if (v.status === 'waiting_payment') {
        }

        if (v.status === 'paid' && v.orderData) {
           this.executeStatus = false
           clearInterval(this.intervalSeconds)
           clearInterval(this.pingPix)
           this.tryCheckStatus = false

            const postOrder = {
              ...this.$store.getters.postOrder,
              ...v.orderData,
              status: 'Aprovado',
              hash_pedido: this.$store.getters.body.hash_pedido || 1,
              payment: this.$store.getters.paymentOption || 'PIX',
              organizador: v.orderData.nome_organizador || 'Nome',
              cpf_organizador: v.orderData.org_cpf || '00',
              cnpj_organizador: v.orderData.org_cnpj || '00',
              mensagem: v.orderData.mensagem_conclusao_pedido || 'm'
            };

            this.$store.dispatch('setPostOrder', postOrder);
            this.$store.commit('SET_TICKET_URL', v.orderData.ticketsUrl);
            this.$store.dispatch('setBody', {
              ...this.$store.getters.body,
              expiration: 0,
            });
            console.log('setPurchaseStarted - pixOrderStatus - false')
            this.$store.dispatch('setPurchaseStarted', false);
            localStorage.setItem('iframePurcheased', true);
            this.$store.dispatch('nextStep')
            if (this.$route.name === 'totem') this.$store.commit('SET_PRINT_TICKETS', true)
            // this.$store.dispatch('confirmOrder');
        }
      }
  },
  methods: {
      clearIntervalPing () {
          clearInterval(this.pingPix)
      },
      returnToOptions () {
        this.executeStatus = false
        this.$store.commit('SET_SECOND_PAYMENT_STEP', false)
        this.$store.commit('SET_PIX_SELECTED', false)
        this.$store.commit('SET_PIX_DETAILS', null)
        this.$store.commit('SET_PIX_ORDER_STATUS', null)
        this.clearIntervalPing()
      },
      async checkPurchaseStatus () {
        if (this.executeStatus) {
          var pix = this.pixDetails
          var store = this.$store
          try {
            store.dispatch('subtractLoading')
            let headers = {'checkout': 'one-checkout'}
            if (!this.expired) this.intervalSeconds = await setInterval(() => {this.incrementSeconds()}, 1000);
            this.countRequest += 1
            if (this.countRequest >= 150) this.timer = 6000
            const { data } = await $http.get(`pdv/orders/charge/status?order_hash=${pix && pix.order_hash ? pix.order_hash: null}`, null, {headers});
            clearInterval(this.intervalSeconds)
            if (data) {
              this.seconds = 0
              clearInterval(this.intervalSeconds)
              store.commit('SET_ORDER_DATA', data)
            }
            store.commit('SET_PIX_ORDER_STATUS', data)
            if (data && data.status !== 'paid' && !this.expired) {
              setTimeout(() => {
                this.checkPurchaseStatus()
              }, this.timer)
            }
          } catch (error) {
              clearInterval(this.intervalSeconds)
              throw error;
          }
        }
      },
      async incrementSeconds() {
        this.seconds += 1;
        if (this.seconds === 15) {
          this.seconds = 0
          await clearInterval(this.intervalSeconds)
          this.checkPurchaseStatus()
        }
      },
      copyCode() {
      const pixLink = document.querySelector('#copy-domain');

      pixLink.setAttribute('type', 'text')
      pixLink.select()


      try {
        document.execCommand('copy');
        this.copyBtn = 'Copiado';
          this.$store.dispatch('openSnackbar', {
            message: 'Link Copiado!', color: 'success'
          });
      } catch (err) {
                  this.$store.dispatch('openSnackbar', {
            message: 'Erro ao copiar link, tente novamente!', color: 'error'
          });
      }

      pixLink.setAttribute('type', 'hidden')
      window.getSelection().removeAllRanges()
    },
  }
};
</script>

<style scoped>
.link-btn{
    color: #1976D2;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
}

.title-card{
    color: #192B46;
    font-size: 20px;
    font-weight: bold;
}

.subtitle-card{
    color: #192B46;
    font-size: 16px;
    font-weight: 500;
}

.discount {
    color: #00A65A;
    font-size: 16px;
    font-weight: 500;
}
.footer-card {
    color: #1976D2;
    font-size: 16px;
    font-weight: 500;
    text-align: center;
}
</style>

<style>
.half-circle-spinner.loading-circular {
  position: relative !important;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 10px !important;
  z-index: 100000;
}
</style>
